import { LabelInfoData } from '../MainScreen/MainScreenSlice';

let systemLabelInfo: LabelInfoData = {};

export const setSystemLabelInfo = (labelInfo: LabelInfoData) => {
  systemLabelInfo = labelInfo;
};

export const getSystemLabel = (key: keyof LabelInfoData | `buddyTypes.${string}`): string | string[] | null => {
  if (key.startsWith('buddyTypes.')) {
    const roleKey = key.split('.')[1];
    const roleDisplayName = systemLabelInfo.buddyTypes?.[roleKey];
    return roleDisplayName?.trim() ? roleDisplayName : null;
  }

  if (key === 'sayHelloAskMeAboutLabel') {
    const arr = systemLabelInfo.sayHelloAskMeAboutLabel;
    return Array.isArray(arr) && arr.length > 0 ? arr : null;
  }

  const value = systemLabelInfo[key as keyof LabelInfoData];
  return typeof value === 'string' && value.trim() ? value : null;
};
